/** Superficie pública del bounded context Informes (Reports). Re-exporta desde domain-api, infra-api, app-api + UI directa. */
export * from './domain-api';
export * from './infra-api';
export * from './app-api';

// UI — se mantiene directo en public-api
export { ReportsScreen } from './screens/ReportsScreen';
